const baseUrl = `${process.env.PROTOCOL}${window.location.host.split('.')[0]}.${process.env.API_URL}`
export default baseUrl



// WEBPACK FOOTER //
// ./src/utils/base-url.js